// extracted by mini-css-extract-plugin
export default {"inputComp":"Style_inputComp__cOuZU","readOnlyClass":"Style_readOnlyClass__6-KdX","ErrorField":"Style_ErrorField__jGKSV"};